// extracted by mini-css-extract-plugin
module.exports = {"loadingWrapper":"CustomShippingOptionModal_loadingWrapper__n7u_X"};